module.exports = __webpack_public_path__ + "img/tuf15.9eb5ca86.jpg";